var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    viewBox: "63.42 228.19 336.75 312.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.88,
    cy: 330.23,
    fill: "rgba(216, 216, 216, 0)",
    fillRule: "nonzero",
    id: "svg_1",
    rx: 93.96,
    ry: 93.96,
    stroke: "rgb(0, 0, 0)",
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 2.842170943040401e-14, 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.3,
    cy: 438.85,
    fill: "rgba(216, 216, 216, 0)",
    id: "svg_2",
    rx: 93.96,
    ry: 93.96,
    stroke: "rgb(0, 0, 0)",
    strokeWidth: "15px",
    transform: "matrix(1 0 0 1 2.84217e-14 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.71,
    cy: 329.65,
    fill: "rgba(216, 216, 216, 0)",
    id: "svg_3",
    rx: 93.96,
    ry: 93.96,
    stroke: "rgb(0, 0, 0)",
    strokeWidth: "15px",
    transform: "matrix(1, 0, 0, 1, 2.842170943040401e-14, 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4c525e0488c1c8b8a06f3d6947702c74.svg";
export { ForwardRef as ReactComponent };